export default "/wp-content/themes/onnit/script/cart/dist/abPreOverride-cf14d6a3.png";